// tarifficators
import {
  TarrificatorMenskings,
  TarrificatorParma,
  TarrificatorTumen,
  TarrificatorTwoPeriods,
  TarrificatorDaily,
  TarrificatorHourlyDayNight,
  TarrificatorIgora,
  TarrificatorPeriodic,
  TarrificatorInterval,
} from './';

// cmp
export const Tarrificator = (props) => {
  const { template, info, selectedZone, setZone, tariffication, disabled, zones, newIndividual, tarifficatorType } = props;

  let Cmp = null;

  // console.log('🚀 ~ Tarrificator ~ info:', info);
  // console.log('🚀 ~ Tarrificator ~ template:', template);
  // console.log('🚀 ~ Tarrificator ~ tarifficatorType:', tarifficatorType);

  // params
  const params = {
    type: info.type,
    selectedZone,
    setZone,
    zones,
    initialValue: template ? template : info,
    tariffication,
    disabled,
    newIndividual,
  };

  // render
  switch (tarifficatorType) {
    case 'menskings':
      Cmp = TarrificatorMenskings;
      break;
    case 'igora':
      Cmp = TarrificatorIgora;
      break;
    case 'tumen':
      Cmp = TarrificatorTumen;
      break;
    case 'Daily':
      Cmp = TarrificatorDaily;
      break;
    case 'HourlyDayNight':
      Cmp = TarrificatorHourlyDayNight;
      break;
    case 'parma':
      Cmp = TarrificatorParma;
      break;
    case 'two_periods':
      Cmp = TarrificatorTwoPeriods;
      break;
    case 'interval': 
      Cmp = TarrificatorInterval;
      break;
    default:
      Cmp = TarrificatorPeriodic;
      break;
  }
  return <Cmp {...params} />;
};
